<template>
	<div>
		<h2 class="detail-title u-container">{{ title }}</h2>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
	},
};
</script>

<style scoped>
.detail-title {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	height: 2.25rem;
	font-size: 1rem;
	background: #ededed;
}
</style>
